import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { AxisTickProps } from '@nivo/axes';
import { range } from 'lodash';
import { useHistory } from 'react-router-dom';
import { WidgetName } from '../../../shared/models/insights';

const MAX_RATING = 5;

const commonProps = {
  indexBy: 'rating',
  keys: ['value'],
  margin: { left: 120 },
  padding: 0.2,
  labelTextColor: 'inherit:darker(1.4)',
  labelSkipWidth: 16,
  labelSkipHeight: 16,
};

const CustomTick = (tick: AxisTickProps<string>) => {
  const { x, y } = tick;
  return (
    <g transform={`translate(${x},${y})`}>
      {range(0 , MAX_RATING,1).map((value) => {
        return (
          <React.Fragment key={value}>
            <text
              textAnchor="middle"
              dominantBaseline="middle"
              style={{
                // eslint-disable-next-line react/destructuring-assignment
                fill: value + 1 <= +tick.value ? '#fd8d1d' : '#fff',
                fontSize: 20,
              }}
            >
              {/* eslint-disable-next-line react/destructuring-assignment */}
              <tspan width={20} x={(- 20) * (MAX_RATING - value)} fill={tick.value} stroke="#7f4001" strokeWidth="1" strokeLinecap="round">
                ★
              </tspan>
            </text>
          </React.Fragment>
        );
      })}
    </g>
  );
};

interface RatingChartProps {
  data: number[];
}

const RatingChart = (props: RatingChartProps) => {
  const { data } = props;
  const history = useHistory();

  const clickHandler = (rowData) => {
    history.push(`/insights/tasks/${WidgetName.FeedbackRating}/${rowData.indexValue}`);
  }

  return (
    <ResponsiveBar
      {...commonProps}
      data={data.map((v, i) => ({ rating: i, value: v})).filter((v, i) => i > 0 && i <= MAX_RATING )}
      colors={[
        "#FF6A13"
      ]}
      layout="horizontal"
      animate={false}
      axisLeft={{
        renderTick: CustomTick,
      }}
      axisBottom={null}
      onClick={clickHandler}
    />
  );
};

export default RatingChart;
